var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"},attrs:{"id":"app"}},[_c('OfflineBar'),(_vm.showOnline)?_c('OnlineBar'):_vm._e(),_c('loading-overlay',{attrs:{"is-loading":_vm.isLoading}}),_c('router-view'),_c('OfflineWarningModal'),_c('FeatureUnavailableOfflineModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }